export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserMenu.vue?vue&type=template&id=a19e96f6&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Layout/Extra/UserMenu.vue?vue&type=template&id=a19e96f6&scoped=true
// module id = 1671
// module chunks = 31